// extracted by mini-css-extract-plugin
module.exports = {"container":"ranking-status-container__6GdU7","btn":"ranking-status-btn__3sMqU","hide":"ranking-status-hide__1a-Ik"};